export function getApiBaseUrl(isSSR, baseUrl) {
    if (!isSSR) {
        return location.host;
    }
    var parsedUrlObject = new URL(baseUrl !== null && baseUrl !== void 0 ? baseUrl : '');
    return "".concat(parsedUrlObject.hostname).concat(parsedUrlObject.pathname !== '/' ? parsedUrlObject.pathname : '');
}
//# sourceMappingURL=getWixApiBaseUrl.js.map